export default {
  router: [
    {
      exact: true,
      path: '/bbc/bbcNoDeliveryArea',
      title: '不发货区域',
    },
  ],
  title: '不发货区域',
};
